/**
 * ContactFormSheet.js — WhatsApp contact-card composer sheet (#121).
 *
 * Pure presentational component extracted from Composer.js. State lives
 * in the parent Composer and is passed down via props. Required-field
 * validation happens in the parent's submit handler.
 */

import { html } from 'htm/preact';

export function ContactFormSheet({ form, setForm, onClose, onSubmit }) {
  if (!form) return null;

  return html`
    <div class="inbox-sheet-overlay" style="display:block" onClick=${onClose}></div>
    <div
      class="inbox-bottom-sheet"
      style="display:flex;flex-direction:column;max-height:85vh;background:var(--v2-bg-elevated, #131722)"
      role="dialog"
      aria-modal="true"
      aria-label="Send contact card"
      onClick=${(e) => e.stopPropagation()}
    >
      <div class="inbox-sheet-handle"></div>
      <div class="inbox-sheet-header">
        <h3 class="inbox-sheet-title">👤 Send contact</h3>
        <button class="inbox-sheet-close" onClick=${onClose}>×</button>
      </div>
      <div style="padding:12px 14px 16px;overflow-y:auto">
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">
          <div>
            <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">First name *</label>
            <input
              type="text"
              value=${form.firstName}
              onInput=${(e) => setForm({ ...form, firstName: e.target.value })}
              placeholder="Sambit"
              style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem"
            />
          </div>
          <div>
            <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Last name</label>
            <input
              type="text"
              value=${form.lastName}
              onInput=${(e) => setForm({ ...form, lastName: e.target.value })}
              placeholder="Swarup"
              style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem"
            />
          </div>
        </div>

        <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Phone number *</label>
        <input
          type="tel"
          value=${form.phoneNumber}
          onInput=${(e) => setForm({ ...form, phoneNumber: e.target.value })}
          placeholder="+91 98xxxxxxxx"
          style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem;margin-bottom:10px"
        />

        <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Email (optional)</label>
        <input
          type="email"
          value=${form.email}
          onInput=${(e) => setForm({ ...form, email: e.target.value })}
          placeholder="hello@odivend.com"
          style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem;margin-bottom:10px"
        />

        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">
          <div>
            <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Company (optional)</label>
            <input
              type="text"
              value=${form.company}
              onInput=${(e) => setForm({ ...form, company: e.target.value })}
              placeholder="ODIV Engage"
              style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem"
            />
          </div>
          <div>
            <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Title (optional)</label>
            <input
              type="text"
              value=${form.title}
              onInput=${(e) => setForm({ ...form, title: e.target.value })}
              placeholder="Founder"
              style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem"
            />
          </div>
        </div>

        <button
          onClick=${onSubmit}
          disabled=${form.pending}
          style="width:100%;background:#25D366;color:#0a0c12;border:none;border-radius:10px;padding:12px;font-size:0.88rem;font-weight:700;cursor:${form.pending ? 'wait' : 'pointer'};opacity:${form.pending ? 0.7 : 1}"
        >${form.pending ? 'Sending…' : 'Send contact card'}</button>
      </div>
    </div>
  `;
}
